import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { apiSlice } from '@/api'
import { adminServiceApiSlice } from '@/api/adminServiceApi'
import { aiAdminApiSlice } from '@/features/ai-assistant/ai-api'
import { systemSettingsApiSlice } from './pages/system-settings/system-settings-api'
import { devicePanelApiSlice } from './pages/device-panel/device-panel-api'
import * as reducer from './reducers'

// Register RTK Query endpoint injections on the shared apiSlice.
import '@/api/abonements'
import '@/api/banners'
import '@/api/billing'
import '@/api/camera'
import '@/api/channels'
import '@/api/enterance'
import '@/api/whiteList'
import './pages/partners/partners-api'
import './pages/main/components/incidents/incidents-api'
import './layout/main-api'
import './pages/login/auth-api'
import './pages/users/users-api'
import './pages/monitoring/monitoring-api'
import './pages/main/components/report/report-api'
import './pages/main/components/reports/reports-api'
import './pages/main/components/parking-places/api-slice'
import './pages/main/components/payment-partners/tariff-api'
import './pages/main/components/logging-gates/api-slice'
import './pages/permission-settings/api-slice'
import './pages/main/components/helmets/helmets-api'
import './pages/main/components/persons-channels/api-slice'

const rootReducer = combineReducers({
  ...reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [adminServiceApiSlice.reducerPath]: adminServiceApiSlice.reducer,
  [aiAdminApiSlice.reducerPath]: aiAdminApiSlice.reducer,
  [systemSettingsApiSlice.reducerPath]: systemSettingsApiSlice.reducer,
  [devicePanelApiSlice.reducerPath]: devicePanelApiSlice.reducer,
})

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'building']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

/** @type {import('@reduxjs/toolkit').Middleware[]} */
const apiMiddleware = [
  apiSlice.middleware, 
  adminServiceApiSlice.middleware,
  aiAdminApiSlice.middleware,
  systemSettingsApiSlice.middleware,
  devicePanelApiSlice.middleware,
]

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(apiMiddleware),
  devTools: import.meta.env.DEV
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
